/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {CardsModal} from './invoiceHistoryList/components/modal/CardsModal'
import {creditCardResponse} from '../core/_models'
import {getCreditCards, removeCreditCard} from './invoiceHistoryList/core/_requests'
import Swal from 'sweetalert2'

type Props = {
  dataCreditCards: creditCardResponse[]
  franchiseId: number
  setDataCreditCards: React.Dispatch<React.SetStateAction<creditCardResponse[]>>
  setLoadingCredtCardContentProgress: React.Dispatch<React.SetStateAction<boolean>>
}

const MyCard: React.FC<Props> = ({
  dataCreditCards,
  franchiseId,
  setDataCreditCards,
  setLoadingCredtCardContentProgress,
}: Props) => {
  const [showCreditCards, setShowCreditCards] = useState(false)
  const [selectedCard, setSelectedCard] = useState<any | null>(null)

  const bandeiras: Record<string, string> = {
    visa: '/media/svg/card-logos/visa.svg',
    mastercard: '/media/svg/card-logos/mastercard.svg',
    elo: '/media/svg/card-logos/elo.svg',
    amex: '/media/svg/card-logos/american-express.svg',
    hipercard: '/media/svg/card-logos/hipercard.svg',
    hiper: '/media/svg/card-logos/hiper.svg',
    diners: '/media/svg/card-logos/diners.svg',
    discover: '/media/svg/card-logos/discover.svg',
    jcb: '/media/svg/card-logos/jcb.svg',
    maestro: '/media/svg/card-logos/maestro.svg',
    mir: '/media/svg/card-logos/mir.svg',
    paypal: '/media/svg/card-logos/paypal.svg',
    unionpay: '/media/svg/card-logos/unionpay.svg',
    generic: '/media/svg/card-logos/generic.svg',
  }

  const removeCreditCards = async (creditCardId: number) => {
    await Swal.fire({
      title: 'Deseja remover o cartão?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingCredtCardContentProgress(true)
        try {
          // setLoadingStarprogress(true)
          const removeMessage = await removeCreditCard(franchiseId, creditCardId)
          const cards = await getCreditCards(franchiseId)
          setDataCreditCards(cards)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: removeMessage.message,
            showConfirmButton: false,
            timer: 1500,
          })
        } catch (error: any) {
          await Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: error?.response?.data?.message,
          })
        } finally {
          setLoadingCredtCardContentProgress(false)
        }
      }
    })
  }
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Meus Cartões</h3>
        </div>
      </div>

      <div className='card-body border-top '>
        <div className='row'>
          {dataCreditCards?.map((card, index) => (
            <div className='col-xl-6 my-3' key={`card${card.id}`}>
              <div className='card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6'>
                <div className='d-flex flex-column py-2'>
                  <div className='d-flex align-items-center fs-4 fw-bold mb-5'>
                    {card?.holderName}
                    {card?.isFavorite > 0 && (
                      <span className='badge badge-light-success fs-7 ms-2'>Principal</span>
                    )}
                  </div>

                  <div className='d-flex align-items-center'>
                    <img
                      src={bandeiras[card?.brand?.description?.toLowerCase()] || ''}
                      alt={card?.brand?.description}
                      style={{width: 60}}
                      onError={(e) => {
                        e.currentTarget.src = bandeiras['generic']
                      }}
                      className='me-4'
                    />
                    <div>
                      <div className='fs-4 fw-bold'>
                        {card?.brand?.description} **** {card.lastNumbers}
                      </div>
                      <div className='fs-6 fw-semibold text-gray-500'>
                        O cartão expira em {`${card?.expirationMonth}/${card?.expirationYear}`}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flex align-items-center py-2'>
                  <button
                    className='btn btn-sm btn-light btn-active-light-danger me-3'
                    onClick={() => removeCreditCards(card.id)}
                  >
                    Remover
                  </button>
                  <button
                    className='btn btn-sm btn-light btn-active-light-danger me-3'
                    onClick={() => {
                      setSelectedCard(card)
                      setShowCreditCards(true)
                    }}
                  >
                    Alterar
                  </button>
                </div>
              </div>
            </div>
          ))}
          <div className='col-xl-6'>
            <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed h-lg-100 p-6'>
              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-semibold'>
                  <h4 className='text-gray-900 fw-bold'>Importante!</h4>

                  <div className='fs-6 text-gray-700 pe-7'>
                    Os cartões adicionados poderão ser utilizados para a cobrança e o pagamento das
                    faturas de forma automática.
                  </div>
                </div>

                <button
                  className='btn btn-danger px-6 align-self-center text-nowrap'
                  onClick={() => {
                    setSelectedCard(null)
                    setShowCreditCards(true)
                  }}
                >
                  Adicionar Cartão
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showCreditCards && (
        <CardsModal
          creditCard={selectedCard}
          franchiseId={franchiseId}
          onClose={() => setShowCreditCards(false)}
          setDataCreditCards={setDataCreditCards}
          setLoadingCredtCardContentProgress={setLoadingCredtCardContentProgress}
        />
      )}
    </div>
  )
}

export {MyCard}
